import { LockService } from "../../api/lock-service";
import { EOSService } from '../../api/eos-service'
import ApiService from "../../api/apiservice";
import EosUtils from "../../utils/EosUtils";
import PushNotificationHelper from "../../notification/PushNotificationHelper";

const initialState = () => {
    return {
        lockData: {},
        customerName:''
    }
}
const state = initialState()

const getters = {};

const actions = {
    async IsLockActive() {
        return await EOSService.makeRequest(LockService.IsLockActive())
    },
    async GetLockData(context) {
        let callback = function (response) {
            if (response?.data) {
                var data = response.data
                if (data.ResponseResultType === 1) {
                    let lockData = data.Values[0];
                    //console.log(lockData);
                    context.commit('setLockData', lockData)
                }
            }
        }
        return await EOSService.makeRequest(LockService.GetLockData(), callback)
    },
    async CheckHaveAccessToMobkart() {
        return await EOSService.makeRequest(LockService.CheckHaveAccessToMobkart())
    },
    async GetCustomerName() {
        //debugger
        return await EOSService.makeRequest(LockService.GetCustomerName())
    },
    async hasActiveDirectory() {
        return await EOSService.makeRequest(LockService.hasActiveDirectory())
    },
    async IsValidDomainLoginName(context, { params }) {
        var _params = new URLSearchParams()
        _params.append('domainUser', params.domainUser)
        var result = await EOSService.makeRequest(LockService.IsValidDomainLoginName(_params))
        if (result.response && !params.ischeck) {
            var username = result.response.perno
            var token = result.response.token
            //console.log(perno);
            var auth = {
                token: token,
                username: username,
            };
            context.commit('setAuth', auth, { root: true });
            const headers = {
                'token': `${auth?.token || ''}`,
                'username': `${auth?.username || ''}`,
            }
            ApiService.setHeader(headers);
            if (!EosUtils.isWebKartAdmin() && username != '000') {
                var perno = auth.username
                await context.dispatch('getPersonDetail', { perno }, { root: true })
                await context.dispatch('getPermission', { auth }, { root: true })
            }
            PushNotificationHelper.registerServiceWorker()
        }
        return result
    },
};

const mutations = {
    setLockData: (state, lockData) => (state.lockData = lockData),

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}